import { DOT_SIZE, MODE, TAG_SIZE, TAG_SIZE_HOVERED, DOT_SIZE_HOVERED } from './constants';

const COMPUTE_TAGS_OPTIONS = {
	mode:                    MODE.DEFAULT,
	zoomLevel:               1,
	zoomStart:               0,
	highlightedTags:         [],
	participants:            [],
	duration:                0,
	isSequentialCompetition: false,
	isLandscape:             false,
};
export const computeTags = (tags, options = {}) => {
	const opts = { ...COMPUTE_TAGS_OPTIONS, ...options };

	let timelineTags = tags.slice();

	// filter out tagging_tool_only tags
	if (opts.mode === MODE.VIEW) {
		timelineTags = timelineTags.filter(e => !e.taggingToolOnly);
		timelineTags = timelineTags.filter(tag => tag.timeline);
	}

	// sort by (timestamp - secondsBefore)
	timelineTags.sort((a, b) => a.timestamp - a.secondsBefore - (b.timestamp - b.secondsBefore));

	// process
	return timelineTags.map(tag => {
		const { id, imageUrl, name, timestamp, score, scoreIntensity } = tag;
		const key = `timeline-tag-${id}`;
		const time = timestamp;

		// participant handling
		const participantCount = opts.participants.length;
		const participantIndex = opts.participants.findIndex(participant => participant.id === tag.participant);
		const isNeutralTag = participantIndex === -1; // not participant specific

		// tag left position
		const left = (timestamp * 100) / opts.duration;

		// tag top position
		let top = 50;
		let offset = 0;
		if (opts.isMobileViewport) {
			if (opts.isLandscape && !isNeutralTag) {
				// mobile landscape
				top = participantIndex < 1 ? 15 : 85;
			} else if (!opts.isLandscape) {
				top = 25; // mobile portrait
			}
		} else if (!isNeutralTag && !opts.isSequentialCompetition && participantCount === 2) {
			offset = participantIndex % 2 === 0 ? 20 / participantCount : -20 / participantCount;
			top = ((participantIndex + 1) * 100) / participantCount - 100 / participantCount / 2 - offset;
		}

		// tag style
		const style = {
			left:   `${left}%`,
			width:  `${tag.hovered ? TAG_SIZE_HOVERED : TAG_SIZE}px`,
			height: `${tag.hovered ? TAG_SIZE_HOVERED : TAG_SIZE}px`,
			top:    `calc(${top}% - ${tag.hovered ? DOT_SIZE_HOVERED : DOT_SIZE}px)`,
		};

		// tag type
		const type = isNeutralTag ? 'neutral' : 'participant';

		return {
			id,
			key,
			style,
			type,
			time,
			name,
			score,
			scoreIntensity,
			image:            imageUrl,
			participantIndex,
			participant:      participantIndex !== -1 ? opts.participants[participantIndex] : null,
			tag,
			topPosition:      top, // need for multi tags to calculate top since here we can't detect them easy here
			isNeutral:        type === 'neutral',
			showAsTagPreview: ['cut'].includes(tag.tag?.name) || opts.isSingleSport, // show as tag preview instead of Tooltip (Tooltip is for example for clock specific, neutral tags)
		};
	});
};

export const computeHighlightPercentage = ({ elapsed = 0, duration = 0 }) => {
	return (elapsed * 100) / duration;
};
